import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { MainProvider } from '../providers/mian.provider';
import { UserService } from '../services/user.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // 1. Inject your services (Functional interceptors use inject() instead of constructors)
  const router = inject(Router);
  const toaster = inject(ToastrService);
  const mainProvider = inject(MainProvider);
  const userService = inject(UserService);

  // 2. Attach the token to the outgoing request
  let authReq = req;
  const storedData = localStorage.getItem('WD-TOKEN');
  
  if (storedData) {
    const currentUser = JSON.parse(storedData);
    if (currentUser?.access_token) {
      authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${currentUser.access_token}` }
      });
    }
  }

  // 3. Send the request and listen for errors
  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {

      // === 401 UNAUTHORIZED: Token is completely dead ===
      if (error.status === 401) {
        localStorage.removeItem('WD-TOKEN'); // Clear bad data
        // toaster.error('Authentication failed. Please Login again!');
        router.navigate(['/authentication/login']);
        
        return throwError(() => error);
      }

      // === 403 FORBIDDEN: Token expired, try to refresh ===
      if (error.status === 403) {
        
        let savObj = {
          user_id: userService.getUserId,
        };

        return mainProvider.refreshToken(savObj).pipe(
          switchMap((resp: any) => {
            // If the refresh was successful
            if (resp.responseCode === 200) {
              const newAccessData = resp.data;
              const currentStoredData = localStorage.getItem('WD-TOKEN');

              if (currentStoredData) {
                // Update Local Storage
                let currentUser = JSON.parse(currentStoredData);
                currentUser.access_token = newAccessData.access_token;
                localStorage.setItem('WD-TOKEN', JSON.stringify(currentUser));
                console.log('Token successfully refreshed and stored!');

                // Clone the ORIGINAL request that failed, but give it the NEW token
                const retryReq = req.clone({
                  setHeaders: { Authorization: `Bearer ${newAccessData.access_token}` }
                });

                // Send the original request again seamlessly
                return next(retryReq);
              }
            }
            
            // If the refresh API returned something other than 200, force logout
            localStorage.removeItem('WD-TOKEN');
            router.navigate(['/authentication/login']);
            return throwError(() => new Error('Refresh failed'));
          }),
          catchError((refreshErr) => {
            // If the refresh API itself throws a network error, force logout
            localStorage.removeItem('WD-TOKEN');
            router.navigate(['/authentication/login']);
            return throwError(() => refreshErr);
          })
        );
      }

      // For any other errors (404, 500, etc.), just pass them along
      return throwError(() => error);
    })
  );
};